export default __webpack_public_path__ + "static/media/bg-set-profile-details.8b501a04.png";